import React from 'react'
import { Col, Row } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalViewExams = (props) => {

    const {

        // ? DATA EXAMS
        modalViewExamsP,
        toggleModalViewExams,
        viewExamsProfile
    } = props;

    return (
        <Dialog
            visible={modalViewExamsP}
            onHide={toggleModalViewExams}
            // header="Exámenes que conforman el Perfil"
            modal
            // className="custom-discount-modal"
            maskClassName="custom-discount-mask"
            draggable={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-flask"></i>                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Exámenes que conforman el Perfil
                            </div>


                        </div>

                    </div>
                </div>
            }

            className={`Global-dialog Global-dialog Global-blue Global-small-v `}

        >
            <Col sm="12" className='p-l-0 p-r-0' >

                <Row className='m-t-10'>
                    <Col sm="12" md="12" lg="12" xl="12">

                        {
                            viewExamsProfile.length === 0 ? (
                                <div className="exam-empty">
                                    <i className="icofont icofont-warning-alt"></i>
                                    <span>No hay exámenes para el perfil seleccionado</span>
                                </div>
                            ) : (
                                <div className="exam-list">
                                    {
                                        viewExamsProfile.map((obj, index) => (
                                            <div key={'exam-' + index} className="exam-item">
                                                <i className="icofont icofont-laboratory"></i>
                                                <span>{obj.name}</span>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }

                    </Col>
                </Row>
            </Col>
        </Dialog>

    )
}
